import {
	getViemClients,
} from "@bracket/contractor-next";

import bytes32 from "bytes32";

import {
	bigintize,
	getContractWithABI,
	isBlockHash,
	isAddress,
	type Address,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";



export declare type BracketVaultWithdrawProps = {
	vault: Address;
	amount: number|bigint;
	salt?: string;
	salt_bytes?: string;
	chain?: ValidChainId;
	config?: Config;
	attempt?: number;
	awaitReceipt?: boolean;
	timeout?: number;
}


/**
 * 
 * @param {salt} string unbyted/cleartext representation of the salt, eg "my salt", if not providing this value salt_bytes MUST be provideed.
 * @param {salt_bytes} string the salt in its encrypted/bytes32 state eg "0x123123123", if not providing this value salt MUST be provided.
 * @returns 
 */
export const withdraw = async ({
	vault,
	amount,
	salt,
	salt_bytes,
	config,
	chain = 1,
	awaitReceipt = true,
	timeout = 30000,

}: BracketVaultWithdrawProps, ): Promise<BlockHash> => {

	try {

		if(!salt && !salt_bytes)
			throw new Error("neither salt nor salt_bytes provided, provide either.");

		if(!isAddress(vault))
			throw new Error("property vault should be a blockchain addresss");

		const [pclient, wclient] = await getViemClients({ chainId: chain, config, });
		const [_, abi] = getContractWithABI("BracketVault", chain);
		const bamount = typeof amount === "bigint" ? amount : bigintize(amount, "BRKTETH");
		const address = vault;
		salt = salt_bytes || bytes32({ input: salt, });

		try {

			const {
				request,
				result,
			} = await pclient.simulateContract({
				address,
				abi,
				functionName: "withdraw",
				args: [
					bamount,
					salt,
				],
				account: wclient.account,
			});

			const hash = await wclient.writeContract(request);

			if(isBlockHash(hash)) {
				await awaitReceipt ? pclient.waitForTransactionReceipt({ hash, timeout, }) : null;
				return hash;
			}

			throw new Error("expected result to be a bigint");
		}
		catch( err ) {

			throw new Error(`transaction failed - ${err.message}`)
		}
	}
	catch( err ) {

		throw new Error(`@bracket/contractor-next::BracketVault::withdraw - ${err.message}`);
	}

}
